import React, { useState, useEffect } from 'react';
import styles from './IntroPages.module.css';
import coreXSystemImage from '../images/CoreXSystemLogo.png';
import backgroundImage from "../images/BackgroundForIntroPage.png";
import corexasLogoWithText from "../images/CorexasLogoWithText.png";
import { getLanguageBasedImage } from '../languageutil/ImageUtil';
import { getText } from '../languageutil/translations';

function IntroInfoPage({ navigate }) {
  const [startButton, setStartButton] = useState(null);

  useEffect(() => {
    setStartButton(getLanguageBasedImage('BaslaButton.png'));
  }, []);

  return (
    <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className={styles.content}>
        <div className={styles.leftside}>
          <img src={coreXSystemImage} alt="CoreXFuture" className={styles.corexfutureimage} style={{ marginLeft: "5vw" }} />
          <h2 className={styles.subtitle}>{getText('welcomeTitle')}</h2>
          <p className={styles.description}>{getText('welcomeDescription')}</p>
        </div>
        <div className={styles.rightside}>
          <div className={styles.buttoncontainer}>
            <img src={startButton} alt="Start" className={styles.startbutton} onClick={() => { navigate("/quizstart/startup"); }} />
          </div>
        </div>
      </div>
      <img src={corexasLogoWithText} alt="CoreXFuture" style={{ position: "absolute", height: "10vh", maxHeight: "50px", bottom: "5vh" }} />
    </div>
  );
}

export default IntroInfoPage;
